/* REVIVAL FESTIVAL — attribution for the existing product builder (this page only).
 *
 * The product builder (assets/product-builder.js, unchanged) reads its settings once, when it
 * initialises, from <script type="application/json" data-pb-config> inside its own root, and puts
 * { [trackingKey]: trackingValue } (= "_source": "product-builder") on every line it adds to the cart.
 *
 * This file is loaded with `defer` from a section in the page template. The builder's script is loaded
 * with `defer` from the floating section group at the end of <body>. Deferred scripts run in document
 * order, so this runs first and can change trackingValue in that JSON before the builder reads it.
 * Nothing else about the builder is touched.
 *
 * Safety: if the builder has already initialised (unexpected order) or its settings don't have the
 * expected shape, nothing is changed — lines then keep "_source: product-builder" (never a false
 * REVIVAL attribution). The outcome is recorded on <html data-rf-source="…"> for checking.
 */
(function () {
  'use strict';
  var html = document.documentElement;
  var mark = function (state) { html.setAttribute('data-rf-source', state); };
  var cfgEl = document.getElementById('rf-buy-config');
  var cfg = {};
  try { cfg = JSON.parse(cfgEl ? cfgEl.textContent : '{}'); } catch (e) { cfg = {}; }
  var targetId = cfg.target || 'product-builder-button-floating';
  var source = cfg.source || '';
  if (!source) { mark('off'); return; }

  var root = document.getElementById(targetId);
  if (!root || !root.hasAttribute('data-product-builder')) { mark('no-builder'); return; }
  if (root.dataset.pbReady === 'true') {             // builder already read its settings
    mark('late');
    if (window.console) console.warn('[rf-buy] product builder initialised before rf-buy.js; _source left unchanged');
    return;
  }
  var el = root.querySelector('[data-pb-config]');
  var data = null;
  try { data = JSON.parse(el ? el.textContent : ''); } catch (e) { data = null; }
  if (!data || typeof data !== 'object' || typeof data.trackingKey !== 'string' || !data.trackingKey || !('trackingValue' in data)) {
    mark('unexpected-config');
    if (window.console) console.warn('[rf-buy] product builder settings not in the expected shape; _source left unchanged');
    return;
  }
  data.trackingValue = source;
  el.textContent = JSON.stringify(data);
  root.setAttribute('data-rf-source', source);
  mark('ok');
})();
